import React, { useEffect, useState, memo } from "react";
import { Course10 } from "../imagepath";
import { publicationdetail } from "../../services/publicationService";

// 1. Bileşen dışında global bir cache tutarak aynı parentId isteklerini engelliyoruz.
const coverCache = {}; // { parentId: "resim_url_string" }
const pendingRequests = {}; // { parentId: Promise }

const ChapterCover = memo(({ pub, auth }) => {
  const [coverUrl, setCoverUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getCover = async () => {
      // --- SENARYO A: Yayının kendi kapağı var mı? ---
      if (pub?.coverimage) {
        const url = `https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${pub.mysqlId}/${pub.coverimage}`;
        if (isMounted) {
          setCoverUrl(url);
          setLoading(false);
        }
        return;
      }

      // --- SENARYO B: Kendi kapağı yok, Parent'a bakılacak ---
      // Gelen datada parentId direkt varsa onu alıyoruz
      const pId = pub?.parentid; 

      if (!pId || pId === 0) {
        if (isMounted) {
          setCoverUrl(Course10);
          setLoading(false);
        }
        return;
      }

      // 1. Önce global cache'e bak
      if (coverCache[pId]) {
        if (isMounted) {
          setCoverUrl(coverCache[pId]);
          setLoading(false);
        }
        return;
      }

      try {
        let parentCoverUrl = "";

        // 2. Eğer bu parentId için zaten bir istek yoldaysa, yeni istek atma, mevcut olanı bekle.
        if (pendingRequests[pId]) {
          parentCoverUrl = await pendingRequests[pId];
        } else {
          // 3. İlk defa istek atılıyor; promise'i pendingRequests'e kaydet.
          pendingRequests[pId] = (async () => {
            try {
              const res = await publicationdetail(pId, auth?.token);
              // Gelen örnek dataya göre: res.data.elasticjson.coverimage
              const imgName = res?.data?.elasticjson?.coverimage;
              
              if (imgName) {
                return `https://beta.idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${pId}/${imgName}`;
              }
              return Course10;
            } catch (err) {
              return Course10;
            }
          })();

          parentCoverUrl = await pendingRequests[pId];
          coverCache[pId] = parentCoverUrl; // Cache'le
          delete pendingRequests[pId]; // İşi biten promise'i temizle
        }

        if (isMounted) {
          setCoverUrl(parentCoverUrl);
        }
      } catch (error) {
        if (isMounted) setCoverUrl(Course10);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    getCover();
    return () => { isMounted = false; };
  }, [pub?.mysqlId, pub?.coverimage, pub?.parentid, auth?.token]);

  return (
    <div className="io-chapter-cover-wrapper">
      {loading && (
        <div className="io-cover-spinner">
          <div className="spinner-border spinner-border-sm text-success" />
        </div>
      )}
      <img
        src={coverUrl || Course10}
        alt="publication-cover"
        onLoad={() => setLoading(false)}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = Course10;
          setLoading(false);
        }}
        className="io-fixed-img"
      />
    </div>
  );
});

ChapterCover.displayName = "ChapterCover";
export default ChapterCover;